import {SelectFilterProvider} from '@github-ui/filter-core/providers'
import {PlayIcon} from '@primer/octicons-react'
import {singleValueFilterTypes} from '@github-ui/repos-rules-types/shared-filter-types'
import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter-core'

export class EvaluateStatusFilterProvider extends SelectFilterProvider {
  constructor() {
    super(
      {
        displayName: 'Evaluate status',
        key: 'evaluate-status',
        priority: DEFAULT_FILTER_PRIORITY,
        icon: PlayIcon,
        description: 'Evaluate status: active | evaluate | all',
      },
      [
        {value: 'active', displayName: 'Active rules', priority: 1},
        {value: 'evaluate', displayName: 'Evaluate rules', priority: 2},
        {value: 'all', displayName: 'All rules', priority: 3},
      ],
      {
        filterTypes: singleValueFilterTypes,
      },
    )
  }
}
